import { Validator } from '@vista-digital/validator';
/**
 * Default events for the Item Picker component.
 */
export const itemPickerEventsValidator = Validator.object({
    onItemClicked: Validator.optional(Validator.fn()),
    onItemAddedToCart: Validator.optional(Validator.fn())
});
